import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CarouselComponent } from '../../global/carousel/carousel.component';
import { SlideComponent } from '../../global/carousel/slide/slide.component';
import { MatIcon } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { NgClass } from '@angular/common';
import { PushPipe } from '@ngrx/component';
import { GxWrappedFeedbackComponent } from './gx-wrapped-feedback/gx-wrapped-feedback.component';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { CarouselPopupComponent } from '../../global/carousel/carousel-popup.component';

@Component({
  selector: 'app-gx-wrapped-popup',
  standalone: true,
  imports: [
    CarouselComponent,
    SlideComponent,
    MatIcon,
    NgClass,
    MatDialogClose,
    PushPipe,
    GxWrappedFeedbackComponent,
    MatTooltip,
    TranslateModule,
  ],
  templateUrl: './gx-wrapped-popup.component.html',
  styleUrl: './gx-wrapped-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class GxWrappedPopupComponent extends CarouselPopupComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: string[],
              protected dialogRef: MatDialogRef<GxWrappedPopupComponent>) {
    super(data, dialogRef);
  }
}
